(function($) {
    'use strict';

    // Disable animations while resizing the window
    var animationBlocker = util.animationBlocker(document.body, true);
    $(window).on('resize orientationchange', function() {
        animationBlocker.blockForDelay();
    });

    // Initiate alloy process on document.ready
    $(document).ready(function() {

        // Block animations while the page initialises
        animationBlocker.unblockAfterDelay();

        // Process alloy directives
        mtl.alloy.process(document.body);

        // Polyfill external <use> support for IE
        svg4everybody();

        // Enable smooth-scrolling to local anchor targets
        $(document.body).on('click', 'a', function(event) {

            if (event.isDefaultPrevented()) {
                return;
            }

            var anchor = event.currentTarget;
            var location = window.location;

            var hash = anchor.hash;
            if (!hash) {
                return;
            }

            if (anchor.hostname !== location.hostname || anchor.pathname !== location.pathname) {
                return;
            }

            var $target = $(hash);
            if ($target[0] == null) {
                return;
            }

            util.scroll.toElement($target);

            event.preventDefault();

        });

        // Basic toggler to show/hide franchise section content
        $('a.franchise-toggle').each(function(_index, val) {
            $(val).click(function(e) {
                e.preventDefault();

                $('#franchise-content').toggleClass('hidden');
                $('#franchise-content-long').toggleClass('hidden');
            });
        });

        // Basoc toggler to show/hide Reason content blocks
        $('a.reason-toggle').each(function(_index, val) {
            $(val).click(function(e) {
                e.preventDefault();

                $(val).closest('.article').find('.article__body').toggleClass('hidden');
            });
        });

        // Open/Close full list of reasons
        $('#open-reasons').click(function(e) {
            e.preventDefault();

            $('#reason-supplement').toggleClass('hidden');
            if ($('#reason-supplement').hasClass('hidden')) {
                $('#open-reasons').html('We’ve got more…');
            } else {
                $('#open-reasons').html('Show less');
                util.scroll.toElement('#reason-supplement');
            }
        });

    });

}(jQuery));
